
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planter-dashboard",
      function () {
        return require("private-next-pages/planter-dashboard/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planter-dashboard"])
      });
    }
  